import { TimelineLine, TweenLite } from 'gsap';
import _forEach from 'lodash/forEach';

class ResidentsAnimations {
  constructor() {
    this.triggers = [];
    this.afterLoadTriggers = [];
    this.loaded = false;
  }

  isResidentsPage = () => {
    return document.body.classList.contains('page-residents') || document.body.classList.contains('page-with-us');
  };

  init = () => {
    window.addEventListener('load', this.onLoad);
    window.addEventListener('scroll', this.onScroll);
  };

  onLoad = () => {
    if (!this.isResidentsPage()) {
      return;
    }
    this.loaded = true;
    window.setTimeout(this.startAnimation, 100);
  };

  startAnimation = () => {
    this.addAfterLoadTriggers();
    this.initHero();
    this.addTrigger(
      10,
      '.site-header',
      this.animateHero
    );
    this.initHighlights();
    this.addTrigger(
      30,
      '.highlights-section',
      this.animateHighlights
    );
    this.initLiveResidently();
    this.addTrigger(
      50,
      '.live-residently',
      this.animateLiveResidently
    );
    this.triggerActiveTriggers();
  }

  // If you're looking for 'opacity = 0', that's been done in CSS with the 'animated' class.
  initHero = () => {
    const siteIdentityOuter = document.querySelector('.site-identity-outer');
    siteIdentityOuter.style.transform = 'translateY(-200%)';
  };

  animateHero = (tl) => {
    const siteIdentityOuter = document.querySelector('.site-identity-outer');
    const nav = document.querySelector('.site-nav');
    const heroPrimary = document.querySelector('.site-hero-headline-primary');
    const heroSub = document.querySelector('.site-hero-headline-sub');
    const trustpilot = document.querySelector('.trustpilot');
    siteIdentityOuter.style.opacity = 1;
    tl.to(
      siteIdentityOuter,
      0.7,
      {
        transform: 'translateY(0)',
        ease: Power3.easeOut
      }
    );
    tl.to(
      nav,
      0.7,
      { opacity: 1.0 },
      '-=0.7'
    );
    tl.to(
      heroPrimary,
      0.5,
      { opacity: 1.0 },
      '-=0.4'
    );
    tl.to(
      heroSub,
      0.5,
      { opacity: 1.0 },
      '-=0.2'
    );
    if(trustpilot){
      tl.to(
        trustpilot,
        0.5,
        { opacity: 1.0 },
        '-=0.1'
      );
    }
  };

  initShowcase = () => {
    const showcaseSlides = document.querySelectorAll('.showcase-step.animated');
    const slickArrows = document.querySelectorAll('.showcase-slider-arrow.animated');
    _forEach(showcaseSlides, slide => {
      slide.style.transform = 'translateX(25%)';
    });
    _forEach(slickArrows, arrow => {
      arrow.style.transform = 'scale(0.9)';
    });
  };

  animateShowcase = (tl) => {
    const showcaseSlides = document.querySelectorAll('.showcase-step.animated');
    const slickArrows = document.querySelectorAll('.showcase-slider-arrow.animated');
    if (this.isDesktop()) {
      tl.staggerTo(
        showcaseSlides,
        1.0,
        {
          opacity: 1.0,
          transform: 'translateX(0)',
          ease: Power3.easeOut
        },
        0.125
      );
    } else {
      tl.to(
        showcaseSlides[0],
        1.0,
        {
          opacity: 1.0,
          transform: 'translateX(0)',
          ease: Power3.easeOut
        }
      );
      // No `slice` because NodeList, yay.
      for (let i = 1; i < showcaseSlides.length; i++) {
        const slide = showcaseSlides[i];
        slide.style.opacity = 1.0;
        slide.style.transform = 'translateX(0)';
      }
    }
    _forEach(slickArrows, arrow => {
      tl.to(
        arrow,
        0.3,
        {
          opacity: 1.0,
          transform: 'scale(1.0)',
          clearProps: 'scale'
        },
        '-=0.9'
      );
    });
  };

  initHighlights = () => {
    const highlightsItems = document.querySelectorAll('.highlights-section .highlights__item');
    _forEach(highlightsItems, item => {
      item.style.transform = 'translateX(10%)';
    });
  };

  animateHighlights = (tl) => {
    const highlightsTitle = document.querySelector('.highlights-section .section-header__title');
    const highlightsDescription = document.querySelector('.highlights-section .section-header__description');
    const highlightsItems = document.querySelectorAll('.highlights-section .highlights__item');
    tl.to(
      highlightsTitle,
      0.5,
      { opacity: 1.0 }
    );
    tl.to(
      highlightsDescription,
      0.5,
      { opacity: 1.0 },
      '-=0.2'
    );
    tl.staggerTo(
      highlightsItems,
      1.0,
      {
        opacity: 1.0,
        transform: 'translateX(0)',
        ease: Power3.easeOut
      },
      0.05,
      '-=0.2'
    );
  };

  initTestimonials = () => {
    // Only one testimonal visible so only need to animate the first one.
    const testimonial = document.querySelectorAll('.testimonial')[0];
    const slickArrows = document.querySelectorAll('.testimonials-slider-arrow');
    const profile = testimonial.querySelector('.testimonial-profile');
    const content = testimonial.querySelector('.testimonial-content');
    if (this.isDesktop()) {
      profile.style.transform = 'translate(-25%, 0)';
    }
    if (this.isDesktop()) {
      content.style.transform = 'translate(25%, 0)';
    } else {
      content.style.transform = 'translate(0, 25%)';
    }
    _forEach(slickArrows, arrow => {
      arrow.style.opacity = 0;
      arrow.style.transform = 'scale(0.9)';
    });
  };

  animateTestimonials = (tl) => {
    // Only one testimonal visible so only need to animate the first one.
    const testimonial = document.querySelectorAll('.testimonial')[0];
    const slickArrows = document.querySelectorAll('.testimonials-slider-arrow');
    const profile = testimonial.querySelector('.testimonial-profile');
    const content = testimonial.querySelector('.testimonial-content');
    tl.to(
      profile,
      0.7,
      {
        opacity: 1.0,
        transform: 'translate(0, 0)',
        ease: Power3.easeOut
      }
    );
    tl.to(
      content,
      0.7,
      {
        opacity: 1.0,
        transform: 'translate(0, 0)',
        ease: Power3.easeOut
      },
      '-=0.7'
    );
    _forEach(slickArrows, arrow => {
      tl.to(
        arrow,
        0.3,
        {
          opacity: 1.0,
          transform: 'scale(1.0)',
          clearProps: 'scale'
        },
        '-=0.5'
      );
    });
  };

  initLiveResidently = () => {};

  animateLiveResidently = (tl) => {
    const liveResidentlyContentTitle = document.querySelector('.live-residently__content-title');
    const liveResidentlyParagraphs = document.querySelectorAll('.live-residently__content-inner p');
    tl.staggerTo(
      [ liveResidentlyContentTitle, ...liveResidentlyParagraphs ],
      0.5,
      { opacity: 1.0 },
      0.1
    );
  };

  addTrigger = (priority, selector, callback) => {
    const element = document.querySelector(selector);
    if (!element) { return; }
    const elementBounds = element.getBoundingClientRect();
    const trigger = {
      priority,
      top: elementBounds.top + (window.scrollY || window.pageYOffset),
      bottom: elementBounds.bottom + (window.scrollY || window.pageYOffset),
      callback,
      triggered: false
    };
    this.triggers.push(trigger);
    this.triggers.sort((a, b) => a.priority - b.priority);
  };

  addTriggerAfterLoad = (priority, selector, callback) => {
    if (this.loaded) {
      this.addTrigger(priority, selector, callback);
    } else {
      this.afterLoadTriggers.push([priority, selector, callback]);
    }
  };

  addAfterLoadTriggers = () => {
    _forEach(this.afterLoadTriggers, triggerArgs => this.addTrigger(...triggerArgs));
  };

  isTriggerActive = (trigger, selector) => {
    const viewportHeight = window.innerHeight;
    const viewportTop = window.scrollY || window.pageYOffset;
    const viewportBottom = viewportTop + viewportHeight;
    const viewportEdge = viewportHeight * 0.15;
    const triggerZoneTop = viewportTop + viewportEdge;
    const triggerZoneBottom = viewportBottom - viewportEdge;

    const inView = (
      (triggerZoneTop <= trigger.top && trigger.top <= triggerZoneBottom) ||
      (triggerZoneTop <= trigger.bottom && trigger.bottom <= triggerZoneBottom) ||
      (trigger.top <= triggerZoneTop && triggerZoneBottom <= trigger.bottom)
    );
    return inView;
  };

  onScroll = () => {
    if (!this.isResidentsPage()) {
      return;
    }
    this.triggerActiveTriggers();
  };

  triggerActiveTriggers = () => {

    const masterTl = new TimelineLite();
    masterTl.pause();
    let isFirstTrigger = true;
    _forEach(this.triggers, trigger => {
      if (this.isTriggerActive(trigger)) {
        const childTl = new TimelineLite();
        trigger.callback(childTl);
        if (isFirstTrigger) {
          masterTl.add(
            childTl
          );
          isFirstTrigger = false;
        } else {
          masterTl.add(
            childTl,
            '-=0.9'
          );
        }
        trigger.triggered = true;
      }
    });
    masterTl.play();
    this.triggers = this.triggers.filter(trigger => !trigger.triggered);
  };

  isDesktop = () => window.matchMedia('(min-width: 1024px)').matches;
};

export default new ResidentsAnimations;